import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Box, Flex } from 'theme-ui'
import { ContentfulResource } from 'graphqlTypes'
import { Card, CardRows } from '../Cards'
import { useResource } from '..'

const config = {
  publications: {
    contentfulName: 'Publications',
    slug: 'publications',
    header: 'Publications',
    body: `Reports, commentaries, and peer review publications 
      written by our network members.`,
    key: 'publications',
  },
  multiMedia: {
    contentfulName: 'Multimedia',
    slug: 'multi-media',
    header: 'Multi-media',
    body: `Videos, infographics, and podcasts to help you better understand an
      Arctic on the move.`,
    key: 'multiMedia',
  },
  educationalMaterials: {
    contentfulName: 'Educational Materials',
    slug: 'educational-materials',
    header: 'Educational materials',
    body: `Lesson plans, teaching resources, and educator opportunities to bring
    Arctic migrations into your classroom.`,
    key: 'educationalMaterials',
  },
  memberSpotlights: {
    contentfulName: 'Member Spotlight',
    slug: 'member-spotlights',
    header: 'Member Spotlights',
    body: `Articles on members showcasing their actions on the Arctic environment.`,
    key: 'memberSpotlights',
  },
}

export const Resources = () => {
  const { active } = useResource()

  const data = useStaticQuery(
    graphql`
      query contentfuResource {
        resources: allContentfulResource {
          edges {
            node {
              id
              author
              authorAbout {
                name
                slug
              }
              coverImage {
                fixed(width: 300, height: 300) {
                  ...GatsbyContentfulFixed
                }
              }
              createdAt
              disciplines
              title
              slug
              type
            }
          }
        }
      }
    `
  )

  // create rows for each resource type
  const resourceCards = Object.keys(config).reduce((prev, header) => {
    const resources = data.resources.edges.filter(
      ({ node: resource }: { node: ContentfulResource }) => {
        // filter out only the types that match the header
        return config[header].contentfulName.includes(resource.type)
      }
    )

    resources.sort(({ node: a }, { node: b }) => {
      return a.createdAt < b.createdAt ? 1 : 0
    })

    const cards = resources.map(
      ({ node: resource }: { node: ContentfulResource }, index: number) => {
        return (
          <Flex
            key={resource.id || index}
            sx={{
              flexDirection: ['column', 'row'],
            }}
          >
            <Box
              sx={{
                display: ['inline-block'],
                minWidth: [null, null, null, '300px', '410px'],
                mr: [0, 4],
              }}
            >
              <Card card={resource} />
            </Box>
          </Flex>
        )
      }
    )

    prev[header] = cards

    return prev
  }, {})

  if (active === 'resources') {
    return Object.keys(config).map(header => (
      <CardRows
        key={header}
        cards={resourceCards[header]}
        config={config[header]}
      />
    ))
  } else {
    return (
      <CardRows
        key={active}
        cards={resourceCards[active]}
        config={config[active]}
      />
    )
  }
}

export default Resources
